class Textarea
    constructor: (el) ->
        @.$el = el
        @.$quoteFullEl = @.$el.querySelector '.textarea__quote-full'
        @.$quoteReceiverEl = @.$el.querySelector '.textarea__quote-receiver'
        @.$textarea = @.$el.querySelector 'textarea'

        @.quoteMaxLength = 300
        @.required = @.$textarea.required

        @.$el.classList.add 'textarea--bound'

        @.InitEvents()
        return

    CreateQuoteReceiverEl: (quoteText, quotedUser) ->
        if !@.$quoteReceiverEl
            @.$quoteReceiverEl = document.createElement 'div'
            @.$quoteReceiverEl.classList.add 'textarea__quote-receiver'
            @.$quoteFullEl = document.createElement 'div'
            @.$quoteFullEl.classList.add 'textarea__quote-full'
            if quotedUser && quotedUser != ""
                @.$quoteFullEl.dataset.quotedUser = quotedUser
            if quoteText && quoteText != ""
                @.$quoteReceiverEl.innerHTML = quoteText.substring(0, @.quoteMaxLength) + (if quoteText.length > @.quoteMaxLength then "..." else "")
                @.$quoteFullEl.innerHTML = quoteText
            @.$el.prepend @.$quoteFullEl
            @.$el.prepend @.$quoteReceiverEl
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'textarea-receive-quote', (e) ->
            quotedUser = e.detail?.quotedUser ? false
            quoteText = e.detail?.quoteText ? ""
            if self.$quoteReceiverEl
                self.$quoteReceiverEl.innerHTML = quoteText
            else
                self.CreateQuoteReceiverEl quoteText, quotedUser
            return
        @.$el.addEventListener 'textarea-set-error', (e) ->
            error = e.detail?.error ? false
            self.SetErrorState error
            return
        @.$textarea.addEventListener 'input', (e) ->
            self.SetErrorState if self.required then @.value == "" else false
            return
        return
    
    SetErrorState: (state) ->
        if state
            @.$el.classList.add 'textarea--error'
        else
            @.$el.classList.remove 'textarea--error'
        return

BindTextareas = ->
    document.querySelectorAll '.textarea:not(.textarea--bound)'
        .forEach (el) ->
            new Textarea el
            return
    return

window.addEventListener 'bind-components', BindTextareas

class TextareaCreate
    constructor: (options) ->
        @.$el = null

        @.options = options ? {}

        @.CreateElement()
        if !@.options?.bindLater
            new Textarea @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement 'div'
        @.$el.classList.add 'textarea'
        if @.options.color
            @.$el.classList.add "textarea--#{ @.options.color }"
        if @.options.error
            @.$el.classList.add 'textarea--error'
        if @.options.outline
            @.$el.classList.add 'textarea--outline'
        if @.options.id
            @.$el.id = @.options.id
        if @.options.attrs
            @.$el = window.appUtils.Attributes @.options.attrs, @.$el
        @.$el.innerHTML = "
            #{ if @.options.quoteText then "
                <div class='textarea__quote-receiver'>#{ @.options.quoteText }</div>
                <div class='textarea__quote-full'>#{ @.options.quoteText }</div>
            " else "" }
        "
        textareaEl = document.createElement 'textarea'
        if @.options.autocorrect
            textareaEl.setAttribute 'autocorrect', @.options.autocorrect
        if @.options.cols
            textareaEl.setAttribute 'cols', @.options.cols
        if @.options.dirname
            textareaEl.setAttribute 'dirname', @.options.dirname
        if @.options.disabled
            textareaEl.setAttribute 'disabled'
        if @.options.form
            textarea.setAttribute 'form', @.options.form
        if @.options.maxlength
            textareaEl.setAttribute 'maxlength', @.options.maxlength
        if @.options.minlength
            textareaEl.setAttribute 'minlength', @.options.minlength
        if @.options.name
            textareaEl.setAttribute 'name', @.options.name
        if @.options.placeholder
            textareaEl.setAttribute 'placeholder', @.options.placeholder
        if @.options.readonly
            textareaEl.setAttribute 'readonly'
        if @.options.required
            textareaEl.setAttribute 'required'
        if @.options.rows
            textareaEl.setAttribute 'rows', @.options.rows
        if @.options.spellcheck
            textareaEl.setAttribute 'spellcheck', @.options.spellcheck
        if @.options.value
            textareaEl.value = @.options.value
        if @.options.wrap
            textareaEl.setAttribute 'wrap', @.options.wrap
        if @.options.textareaAttrs
            textareaEl = window.appUtils.Attributes @.options.textareaAttrs, textareaEl
        @.$el.appendChild textareaEl
        return

window.CreateTextarea = (options) ->
    return new TextareaCreate options